import {gql} from "@apollo/client";

export class QueryBuilder {
    constructor(queryName, entityName) {
        this.queryName = queryName;
        this.entityName = entityName;
        this.filterFields = new Map();
        this.returnFields = [];
        this.nodeTree = { name: 'node', children: [] };
        this.defaultFilters = ['orderField', 'first', 'last', 'after', 'before'];
    }

    addFilterField(name, type) {
        this.filterFields.set(name, type);
        return this;
    }

    addReturnField(field) {
        this.returnFields.push(field);
        return this;
    }

    setReturnFields(fields) {
        this.returnFields = fields;
        return this;
    }

    setNodeTree(tree) {
        this.nodeTree = tree;
        return this;
    }

    getNodeTree() {
        return this.nodeTree;
    }

    formatNodeTree(tree, depth) {
        const padding = '    ';
        const offset = 2;
        let formatted = padding.repeat(depth + offset) + tree.name;
        if (tree.children.length > 0) {
            formatted += ' {\n' + tree.children
                    .map(child => this.formatNodeTree(child, depth + 1))
                    .join('\n')
                + '\n}\n';
        }

        return formatted;
    }

    build() {
        const fields = [];
        const params = [];
        const args = [];

        const filters = Array.from(this.filterFields.entries());
        filters.forEach(([name, type]) => {
            if (!fields.includes(name)) {
                params.push(`$${name}: ${type}`);
                args.push(`${name}: $${name}`);
                fields.push(name);
            }
        });

        if (params.length === 0) {
            this.defaultFilters.forEach(field => {
                if (!fields.includes(field)) {
                    params.push(`$${field}: ${this.getFilterType(field)}`);
                    args.push(`${field}: $${field}`);
                    fields.push(field);
                }
            });
        }

        const formattedParams = params.join(',\n        ');
        const formattedArgs = args.join(',\n            ');
        const formattedNodeTree = this.formatNodeTree(this.nodeTree, 0);

        let pageInfo = '';
        if (fields.includes('after') || fields.includes('before')) {
            pageInfo = `
            pageInfo {
                hasNextPage
                startCursor
                endCursor
            }
`;
        }

        const queryString = `
query ${this.entityName}(
    ${formattedParams}
) {
    ${this.queryName}(
        ${formattedArgs}
    ) {
        edges {
${formattedNodeTree}
        }
            count
${pageInfo}
      }
    }
`;

        return gql(queryString);
    }

    getFilterType(field) {
        const types = {
            'orderField': 'String',
            'first': 'Int',
            'last': 'Int',
            'after': 'String',
            'before': 'String'
        };
        return types[field] || 'String';
    }

    formatReturnField(field) {
        if (typeof field === 'string') {
            return `                            ${field}`;
        }
        if (typeof field === 'object' && field.name) {
            if (field.subFields) {
                const subFields = field.subFields
                    .map(subField => `                                ${subField}`)
                    .join('\n');
                return `                            ${field.name} {\n${subFields}\n                            }`;
            }
            return `                            ${field.name}`;
        }
        return '';
    }
}
